/**
 * 「AI エージェントをつなぐ」の画面（/connect・pages/ConnectPage.tsx）とその入口の英語の文言（2026-10-07 console/connect-again）。
 * en.ts が `...enConnect` で取り込む（ja.connect.ts が同じキーを全部持つことを型で強制）。
 * 決め事（指示書）: コピペの 1 行そのもの（home.step.connect.*）は今のまま使い回し、ここには足さない。
 *   ここは「どこにあるか」と「いつ使うか」だけ。普通の人が読んで迷わない文にする。
 *   「chat」は使わない（閉じた機能の言葉として wordsPass.test.ts が止める・connectPage.test.ts も見る）
 */
export const enConnect = {
  // トップバーの入口（狭い画面では文字が隠れてアイコンだけ = aria-label にも同じ文を使う）
  'connect.topbarLink': 'Connect an AI agent',
  'connect.title': 'Connect an AI agent',
  // いつ使うか（founder 2026-10-07「環境変えて使う人もいる」）。クラウドのセッションは「session」「in the cloud」が言葉の検査（plainWords・wording）で止まるので「on the web」と言う。エージェントの名前は例として 3 つ（以前のエージェントのタブ AGENT_CONNECT の main の頭。タブは 2026-10-11 に消した）
  'connect.lead': 'Use the line below when you start on a new computer, in another AI agent (Claude Code, Codex, Cursor and others) or in an AI agent you use on the web.',
  // ホームの「つないだ（済み）」の段に出すリンク
  'connect.elsewhereLink': 'Use {product} in another AI agent or on another computer'
};
